module.exports = __webpack_public_path__ + "static/media/FlyOut-star@3x.2c258e74.png";